import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeClass as _normalizeClass, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-aaf1982c"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["aria-label"]
const _hoisted_2 = {
  key: 0,
  class: "admin-image-tools"
}
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 1,
  role: "alert"
}
const _hoisted_7 = { class: "admin-image-tools" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = ["src", "alt"]

import {nextTick,onBeforeUnmount,ref,watch} from 'vue'
import {imageFitScale} from '@/utils/adminImage'
import store from '@/store'

export default /*#__PURE__*/_defineComponent({
  __name: 'AdminImagePreview',
  props: {
    visible: { type: Boolean },
    src: {},
    title: {},
    count: {},
    index: {},
    busy: { type: Boolean },
    error: {}
  },
  emits: ['update:visible','close','previous','next'],
  setup(__props: any, { emit: __emit }) {

const props=__props
const emit=__emit
const stage=ref<HTMLElement|null>(null),scale=ref(1),size=ref({width:0,height:0}),loading=ref(true),failed=ref(false)
function close(){emit('update:visible',false);emit('close')}
function fit(){scale.value=imageFitScale(size.value.width,size.value.height,(stage.value?.clientWidth || window.innerWidth)-32,(stage.value?.clientHeight || window.innerHeight-110)-32)}
function loaded(event:Event){const image=event.target as HTMLImageElement;size.value={width:image.naturalWidth,height:image.naturalHeight};loading.value=false;failed.value=false;nextTick(fit)}
function zoom(delta:number){scale.value=Math.max(0.1,Math.min(5,Math.round((scale.value+delta)*100)/100))}
function resized(){nextTick(fit)}
function key(event:KeyboardEvent){if(props.visible && event.key==='Escape'){event.stopPropagation();close()}}
function navigationKey(event:KeyboardEvent){
  if(!props.visible || !props.count || props.count<2 || !['ArrowLeft','ArrowRight'].includes(event.key) || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey)return
  event.preventDefault();event.stopImmediatePropagation()
  if(props.busy || event.repeat)return
  if(event.key==='ArrowLeft' && (props.index || 0)>0)emit('previous')
  if(event.key==='ArrowRight' && (props.index || 0)<props.count-1)emit('next')
}
watch(()=>[props.visible,props.src],()=>{if(props.visible){loading.value=true;failed.value=false;size.value={width:0,height:0};scale.value=1;nextTick(fit)}},{immediate:true})
// Private attachment previews must close when the active account or permissions change.
watch(()=>[store.getters.token,store.getters.userInfo?.id,store.getters.userInfo?.orgId,JSON.stringify(store.getters.sysFunctions || {})].join(':'),()=>{if(props.visible)close()},{flush:'sync'})
window.addEventListener('keydown',key);window.addEventListener('keydown',navigationKey,true);window.addEventListener('resize',resized)
onBeforeUnmount(()=>{window.removeEventListener('keydown',key);window.removeEventListener('keydown',navigationKey,true);window.removeEventListener('resize',resized)})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (_ctx.visible)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "admin-image-overlay",
          role: "dialog",
          "aria-modal": "true",
          "aria-label": _ctx.title || '图片预览',
          onClick: _withModifiers(close, ["self"])
        }, [
          _createElementVNode("section", {
            class: _normalizeClass(['admin-image-window',size.value.height>size.value.width?'is-portrait':'is-landscape'])
          }, [
            _createElementVNode("header", null, [
              _createElementVNode("span", null, _toDisplayString(_ctx.title || '图片预览'), 1),
              _createElementVNode("button", {
                type: "button",
                "aria-label": "关闭图片预览",
                onClick: close
              }, "×")
            ]),
            (_ctx.count && _ctx.count>1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("button", {
                    type: "button",
                    "aria-label": "上一张图片",
                    disabled: _ctx.busy || !_ctx.index,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('previous')))
                  }, "‹ 上一张", 8, _hoisted_3),
                  _createElementVNode("span", null, _toDisplayString((_ctx.index || 0)+1) + " / " + _toDisplayString(_ctx.count), 1),
                  _createElementVNode("button", {
                    type: "button",
                    "aria-label": "下一张图片",
                    disabled: _ctx.busy || (_ctx.index || 0)>=_ctx.count-1,
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('next')))
                  }, "下一张 ›", 8, _hoisted_4),
                  (_ctx.busy)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_5, "正在切换图片…"))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.error)
              ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.error), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("button", {
                type: "button",
                disabled: scale.value<=0.1,
                onClick: _cache[2] || (_cache[2] = ($event: any) => (zoom(-0.1)))
              }, "缩小 10%", 8, _hoisted_8),
              _createElementVNode("span", null, _toDisplayString(Math.round(scale.value*100)) + "%", 1),
              _createElementVNode("button", {
                type: "button",
                disabled: scale.value>=5,
                onClick: _cache[3] || (_cache[3] = ($event: any) => (zoom(0.1)))
              }, "放大 10%", 8, _hoisted_9),
              _createElementVNode("button", {
                type: "button",
                onClick: fit
              }, "适应窗口"),
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (scale.value=1))
              }, "原始大小")
            ]),
            _createElementVNode("div", {
              ref_key: "stage",
              ref: stage,
              class: "admin-image-stage",
              onClick: _withModifiers(close, ["self"])
            }, [
              (loading.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_10, "图片加载中…"))
                : (failed.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_11, "图片加载失败，请关闭后重试"))
                  : _createCommentVNode("", true),
              _withDirectives(_createElementVNode("img", {
                src: _ctx.src,
                alt: _ctx.title || '预览图片',
                style: _normalizeStyle({width:size.value.width?size.value.width*scale.value+'px':'auto',height:size.value.height?size.value.height*scale.value+'px':'auto'}),
                onLoad: loaded,
                onError: _cache[5] || (_cache[5] = ($event: any) => {loading.value=false;failed.value=true})
              }, null, 44, _hoisted_12), [
                [_vShow, !loading.value && !failed.value]
              ])
            ], 512)
          ], 2)
        ], 8, _hoisted_1))
      : _createCommentVNode("", true)
  ]))
}
}

})